import { AxiosResponse } from "axios";
import {
  UserEntity,
  UserEntityInput,
  PaginatedTeachersResponse,
  PaginatedStudentsResponse,
} from "./user.types";
import { api } from "../api";

export const getUserById = async (id: number) => {
  try {
    const response: AxiosResponse<UserEntity> = await api.get("/users/" + id);
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const createUser = async (data: UserEntityInput) => {
  try {
    const response: AxiosResponse<UserEntity> = await api.post("/users", data);

    return response.status === 201 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const updateUser = async (id: number, data: UserEntityInput) => {
  try {
    const response: AxiosResponse<UserEntity> = await api.patch(
      "/users/" + id,
      data
    );

    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getTeachersBySchool = async (
  schoolId: number,
  page?: number,
  pageSize?: number,
  gradeId?: number
) => {
  try {
    const searchParams = new URLSearchParams();

    if (page) searchParams.append("page", page.toString());
    if (pageSize) searchParams.append("pageSize", pageSize.toString());
    if (gradeId) searchParams.append("gradeId", gradeId.toString());

    const url = `/users/school/${schoolId}/teachers${
      searchParams.toString() ? `?${searchParams.toString()}` : ""
    }`;

    const response: AxiosResponse<PaginatedTeachersResponse> = await api.get(
      url
    );

    return response.status === 200
      ? response.data
      : {
          data: [],
          total: 0,
          page: 1,
          pageSize: 30,
          totalPages: 0,
        };
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getStudentsBySchool = async (
  schoolId: number,
  page?: number,
  pageSize?: number,
  gradeId?: number
) => {
  try {
    const searchParams = new URLSearchParams();

    if (page) searchParams.append("page", page.toString());
    if (pageSize) searchParams.append("pageSize", pageSize.toString());
    if (gradeId) searchParams.append("gradeId", gradeId.toString());

    const url = `/users/school/${schoolId}/students${
      searchParams.toString() ? `?${searchParams.toString()}` : ""
    }`;

    const response: AxiosResponse<PaginatedStudentsResponse> = await api.get(
      url
    );

    return response.status === 200
      ? response.data
      : {
          data: [],
          total: 0,
          page: 1,
          pageSize: 30,
          totalPages: 0,
        };
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
